import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Card } from "react-bootstrap";
import "./home.scss";

export default function WeightHistory({ weightHistory }) {
	const [chartData, setChartData] = useState({});

	const trimChartData = (weightHistory) => {
		if (weightHistory.weight_chart && weightHistory.weight_chart.length) {
			if (weightHistory.weight_chart.length > 12) {
				const lastElevenItems = weightHistory.weight_chart.slice(
					weightHistory.weight_chart.length - 11,
					weightHistory.weight_chart.length
				);
				const chartData = [weightHistory.weight_chart[0], ...lastElevenItems];
				const labels = [];
				const data = [];
				chartData.map((item) => {
					labels.push(item.x);
					data.push(item.y);
					return null;
				});
				setChartData({ labels, data });
			} else {
				const labels = [];
				const data = [];
				weightHistory.weight_chart.map((item) => {
					labels.push(item.x);
					data.push(item.y);
					return null;
				});
				setChartData({ labels, data });
			}
		}
	};

	useEffect(() => {
		trimChartData(weightHistory);
	}, [weightHistory]);

	const data = (canvas) => {
		const ctx = canvas.getContext("2d");
		const gradient = ctx.createLinearGradient(0, 0, 0, 400);
		gradient.addColorStop(0, "#0074bc");
		gradient.addColorStop(1, "#2cafa4");
		return {
			labels: chartData.data && chartData.data.length ? chartData.labels : [],
			datasets: [
				{
					label: "Weight History",
					backgroundColor: gradient,
					data: chartData.data && chartData.data.length ? chartData.data : []
				}
			]
		};
	};

	const options = {
		maintainAspectRatio: false,
		scales: {
			xAxes: [
				{
					barThickness: 10,
					gridLines: {
						display: false
					}
				}
			]
		}
	};

	return (
		<Card className="weight-history-card-container">
			<Card.Header className="card-header-container">
				<div className="card-header-1">Weight History</div>
				<div>
					{weightHistory && weightHistory.weight_change && (
						<>
							<span className="weight-label">Weight Change</span>
							<span className="weight-value">{weightHistory.weight_change}</span>
						</>
					)}
				</div>
			</Card.Header>
			<Card.Body>
				<Bar data={data} options={options} />
			</Card.Body>
		</Card>
	);
}
